import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/vulnerability-risk-assessment/AssessmentClient.tsx");
